<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="BtnExtra">
            <button type="button" @click="RecargarCalendario" class="btn btn-sm btn-primary">
                <i class="fas fa-redo"></i>
                Recargar
            </button>
        </template>
        
        <template slot="bodyForm">
            <Form></Form>
        </template>
	</CList>
</template>

<script>
import Form from '@/views/modulos/crm/calendario/DataCalendario.vue';
const EmitEjecuta = 'seccionAsignarPersonal';

export default {
    name: 'Calendario',
    props: ['sFiltros','pOrigen','pRegresarBool'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Calendario',
                IsModal: false,
                BtnReturnShow: this.pRegresarBool,
                BtnNewShow: false,
                TitleFirst: '',
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
                ShowFooter: false,
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
        }
    },
    methods: {
        Regresar() {
            this.$router.push({name:'panelSubMenus',params:{}});
        },
        RecargarCalendario()
        {
            this.bus.$emit('reloadCalendar');
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        //this.ConfigLoad.ShowLoader = false;
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
